import {
  mapOfferToBookingOfferLookup,
  type BookingOfferLookup,
} from './offersLookupMapper';

type BookingOfferLookupSource = Parameters<typeof mapOfferToBookingOfferLookup>[0];

export const mapBookingOffersLookupData = (
  offers: BookingOfferLookupSource[] | undefined
): BookingOfferLookup[] =>
  (offers ?? [])
    .map((offer) => mapOfferToBookingOfferLookup(offer))
    .filter((offer): offer is BookingOfferLookup => Boolean(offer));
